import { __awaiter } from "tslib";
import { getBackLink, getOrSetJwt, getWebtexts, save, } from "../../shared/models/api";
import { notify } from "@phoenixreisen/reacts/src/notification";
import Model, { PATH } from "../../shared/models/model";
import Loader from "@phoenixreisen/reacts/src/loader";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Config from "../../../../config";
import striptags from "striptags";
import dt from "date-and-time";
import path from "path";
const ERR_MSG = `Während des Buchungsvorgangs ist leider ein 
Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.`;
export const Summary = () => {
    const navigate = useNavigate();
    const { html } = Config;
    const [error, setError] = useState(null);
    const [wts, setWts] = useState(Model.webtexts);
    const [confirmed, setConfirmed] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const { customer, schedule, visitors, payment } = Model;
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setSubmitting(true);
            yield save(Model, getOrSetJwt());
            location.href = path.join(PATH, "/danke");
        }
        catch (e) {
            notify({
                text: ERR_MSG,
                status: "error",
            });
            setError(e);
        }
        finally {
            setSubmitting(false);
        }
    });
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield getWebtexts();
            setWts(result);
        }))();
    }, [wts]);
    useEffect(() => {
        if (!customer || !schedule || !visitors) {
            navigate("/");
        }
    }, []);
    if (!customer || !schedule || !visitors || !wts) {
        return React.createElement(Loader, null);
    }
    return (React.createElement("section", { className: "summary" },
        React.createElement("h3", { className: "pt0" }, "Zusammenfassung"),
        React.createElement("p", { dangerouslySetInnerHTML: {
                __html: striptags(wts.sb_zusammenfassung, html.allowed),
            } }),
        error && (React.createElement("p", { className: "alert alert--danger alert--icon" },
            React.createElement("i", { className: "fas fa-exclamation-triangle" }),
            "W\u00E4hrend des Buchungsvorgangs ist leider ein Fehler aufgetreten. Bitte versuchen Sie es sp\u00E4ter noch einmal.")),
        React.createElement("div", { className: "row row--2er" },
            React.createElement("div", null,
                React.createElement("h4", { className: "pt0" }, "Besteller"),
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        customer.customerid && (React.createElement("tr", null,
                            React.createElement("th", null, "Kundennr."),
                            React.createElement("td", null, customer.customerid))),
                        React.createElement("tr", null,
                            React.createElement("th", null, "E-Mail"),
                            React.createElement("td", null, customer.email)),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Telefon"),
                            React.createElement("td", null, customer.phone)),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Name"),
                            React.createElement("td", null,
                                customer.gender,
                                React.createElement("br", null),
                                customer.prename,
                                " ",
                                customer.surname)),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Adresse"),
                            React.createElement("td", null,
                                customer.address,
                                React.createElement("br", null),
                                customer.postcode,
                                " ",
                                customer.city,
                                React.createElement("br", null),
                                customer.country)))),
                React.createElement("h4", { className: "pt2" }, "Zahlungsdaten"),
                React.createElement("div", null,
                    React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Zahlungsart"),
                                React.createElement("td", null, payment.method)),
                            payment.iban && (React.createElement("tr", null,
                                React.createElement("th", null, "IBAN"),
                                React.createElement("td", null, payment.iban))))))),
            React.createElement("div", null,
                React.createElement("h4", { className: "pt0" }, "Ihr gew\u00E4hlter Termin"),
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Schiff"),
                            React.createElement("td", null, schedule.schiff.name)),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Datum"),
                            React.createElement("td", null, dt.format(dt.parse(schedule.datum, "YYYY-MM-DD"), "dd, DD.MM.YYYY"))),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Hafen"),
                            React.createElement("td", null, schedule.hafen)))),
                React.createElement("h4", { className: "pt2" }, "Teilnehmer / Besucher"),
                React.createElement("div", { className: "visitor-names" },
                    React.createElement("ol", null, visitors.map((current, pos) => {
                        const v = current.v;
                        return (React.createElement("li", { key: pos },
                            v.gender,
                            " ",
                            v.prename,
                            " ",
                            v.surname,
                            React.createElement("br", null),
                            v.passport && (React.createElement("small", null,
                                v.passport.id,
                                React.createElement("br", null),
                                v.passport.place,
                                React.createElement("br", null),
                                v.passport.from,
                                " - ",
                                v.passport.until))));
                    }))))),
        React.createElement("h4", null, "Allgemeine Gesch\u00E4ftsbedingungen"),
        React.createElement("div", { className: "mb3 form-box" },
            React.createElement("label", { className: "checkbox" },
                React.createElement("input", { type: "checkbox", checked: confirmed, onChange: () => setConfirmed(!confirmed) }),
                React.createElement("span", { className: "checkbox__label" },
                    React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: striptags(wts["sb_agb_label"], html.allowed),
                        } })))),
        React.createElement("div", { className: "mt3 flex justify-between" },
            React.createElement("div", null,
                React.createElement(Link, { to: getBackLink(schedule, "summary"), className: "btn btn--link" },
                    React.createElement("i", { className: "fas fa-arrow-left mr2" }),
                    "Zur\u00FCck")),
            React.createElement("div", null,
                React.createElement("button", { type: "button", onClick: () => submit(), disabled: submitting || !confirmed },
                    submitting ? (React.createElement("i", { className: "fas fa-spinner fa-spin mr2" })) : (React.createElement("i", { className: "fas fa-thumbs-up mr2" })),
                    "Verbindlich buchen")))));
};
export default Summary;
